import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const createCategory = async ({ name, admin }) => {
  const slug = name.toLowerCase().replace(/\s+/g, "-");

  await addDoc(collection(db, "categories"), {
    name,
    slug,
    isActive: true,
    createdBy: {
      uid: admin.uid,
      email: admin.email,
    },
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
};
